<!-- Skill builder header -->
<!-- TODO: Refactor SCSS -->
<div class="tabHeadMain innertabHeadMain innertabHeadMain-sm">
	<div class="container px-0">
		<div class="col-12 d-flex">
			<div class="tabHead col-sm-12 col-md-6 space-between align-items-start">
				<span class="cursor-pointer txt-md">
					<i class="fas fa-arrow-left" (click)="back()"></i>
				</span>
				<span class="text-center-sm pl-2 txt-md">{{ page.title }}</span>
			</div>
		</div>
	</div>
</div>

<!-- Skill builder start flow -->
<ng-container *ngIf="data?.page === ReflectionPage.SCORES">
	<app-member-skill-builder-reflection-scores [data]="data">
	</app-member-skill-builder-reflection-scores>
</ng-container>
<ng-container *ngIf="data?.page === ReflectionPage.SKILL">
	<app-member-skill-builder-reflection-skill [data]="data">
	</app-member-skill-builder-reflection-skill>
</ng-container>
<ng-container *ngIf="data?.page === ReflectionPage.ACTION">
	<app-member-skill-builder-reflection-action [data]="data">
	</app-member-skill-builder-reflection-action>
</ng-container>
<ng-container *ngIf="data?.page === ReflectionPage.SUMMARY">
	<app-member-skill-builder-reflection-summary [data]="data">
	</app-member-skill-builder-reflection-summary>
</ng-container>
